import { readCookie, writeCookie } from '@zapier/cookies';

export const setCookie = (
  id: string,
  value: string,
  maxAge: number,
  path: string = '/'
) => {
  try {
    writeCookie(id, value, {
      // Cookies are categorized as `essential` for backwards compatibility,
      // but devs should use `writeCookie` from `@zapier/cookies` with
      // the correct `category`.
      category: 'essential',
      maxAge,
      path,
    });
  } catch (e) {
    console.error('Unable to set cookie', {
      id,
    });
  }
};

export const getCookie = (id: string) => {
  try {
    return readCookie(id);
  } catch (e) {
    return undefined;
  }
};

export default setCookie;
